module.exports = __webpack_public_path__ + "static/img/wechat-pay.d92b9e08.png";